import Joi from 'joi';
import { YEARS_OSETROVNE } from '../LegalParameters/Constants';

export default Joi.object({
	pay: Joi.number()
		.positive()
		.error(() => ({
			message: 'Hrubá mzda musí být celé kladné číslo.',
		})),
	sickDays: Joi.number()
		.min(1)
		.positive()
		.error(() => ({
			message: 'Počet kalendářních dní ošetřování musí být celé kladné číslo.',
		})),
	lonelyParent: Joi.number()
		.integer()
		.min(9)
		.max(16),
	year: Joi.valid(YEARS_OSETROVNE),
});
